import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/view/login'
import HomePage from '@/view/homepage'
import Welcome from '@/view/welcome'
import bxkmwh from '@/view/xtgl/jcsj/bxkmwh'
import bxkmwhadd from '@/view/xtgl/jcsj/bxkmwhadd'
import xjlxwh from '@/view/xtgl/jcsj/xjlxwh'
import xjlxwhadd from '@/view/xtgl/jcsj/xjlxwhadd'
import khwh from '@/view/xtgl/jcsj/khwh'
import khwhadd from '@/view/xtgl/jcsj/khwhadd'
import rywh from '@/view/xtgl/jcsj/rywh'
import rywhadd from '@/view/xtgl/jcsj/rywhadd'
import ryjqwh from '@/view/xtgl/jcsj/ryjqwh'
import ryjqwhadd from '@/view/xtgl/jcsj/ryjqwhadd'
import lcsz from '@/view/xtgl/splc/lcsz'
import bx from '@/view/bxgl/bx'
import bxadd from '@/view/bxgl/bxadd'
import xjcx from '@/view/kqgl/xjcx'
import njcx from '@/view/kqgl/njcx'
import kqmxcx from '@/view/kqgl/kqmxcx'
import bxtj from '@/view/bbtj/bxtj'
import kqhztj from '@/view/bbtj/kqhztj'
import ggfb from '@/view/xtgl/jcsj/ggfb'
import ggfbadd from '@/view/xtgl/jcsj/ggfbadd'
import jjrwh from '@/view/xtgl/jcsj/jjrwh'
import kqyr from '@/view/kqgl/kqyr'
import kqgzwh from '@/view/xtgl/jcsj/kqgzwh'
import kqgzwhadd from '@/view/xtgl/jcsj/kqgzwhadd'

// import rywh from '@/view/xtgl/rywh' // 人员维护
//import rywhadd from '@/view/xtgl/rywhadd' // 人员维护新增
import jswh from '@/view/xtgl/qxgl/jswh' // 角色维护
import jswhadd from '@/view/xtgl//qxgl/jswhadd' // 角色添加
import qxwh from '@/view/xtgl/qxgl/qxwh' // 权限维护
import cdwh from '@/view/xtgl/qxgl/cdwh' // 角色维护
import cdwhadd from '@/view/xtgl/qxgl/cdwhadd' // 角色添加
import lt from '@/view/ltgl/lt' // 聊天
import dktj from '@/view/kqdk/dktj' // 打卡统计
import rydkmx from '@/view/kqdk/rydkmx' //人员打卡明细
import xjwh from '@/view/xtgl/sjwh/xjwh' //休假维护
import kqwh from '@/view/xtgl/sjwh/kqwh' //考勤维护
import jbwh from '@/view/xtgl/sjwh/jbwh' //加班维护
Vue.use(Router)

export default new Router({ // 此行代码去除url中自带的#符号
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login
        },
        {
            path: '/homepage',
            name: 'HomePage',
            component: HomePage
        },
        {
            path: '/welcome',
            name: 'Welcome',
            component: Welcome
        },
        {
            path: '/bxkmwh',
            name: 'bxkmwh',
            component: bxkmwh
        },
        {
            path: '/bxkmwhadd',
            name: 'bxkmwhadd',
            component: bxkmwhadd
        },
        {
            path: '/xjlxwh',
            name: 'xjlxwh',
            component: xjlxwh
        },
        {
            path: '/xjlxwhadd',
            name: 'xjlxwhadd',
            component: xjlxwhadd
        },
        {
            path: '/khwh',
            name: 'khwh',
            component: khwh
        },
        {
            path: '/khwhadd',
            name: 'khwhadd',
            component: khwhadd
        }, {
            path: '/rywh',
            name: 'rywh',
            component: rywh
        }, {
            path: '/rywhadd',
            name: 'rywhadd',
            component: rywhadd
        }, {
            path: '/ryjqwh',
            name: 'ryjqwh',
            component: ryjqwh
        }, {
            path: '/ryjqwhadd',
            name: 'ryjqwhadd',
            component: ryjqwhadd
        }, {
            path: '/lcsz',
            name: 'lcsz',
            component: lcsz
        }, {
            path: '/bx',
            name: 'bx',
            component: bx
        }, {
            path: '/bxadd',
            name: 'bxadd',
            component: bxadd
        }, {
            path: '/xjcx',
            name: 'xjcx',
            component: xjcx
        }, {
            path: '/njcx',
            name: 'njcx',
            component: njcx
        }, {
            path: '/kqmxcx',
            name: 'kqmxcx',
            component: kqmxcx
        }, {
            path: '/bxtj',
            name: 'bxtj',
            component: bxtj
        }, {
            path: '/kqhztj',
            name: 'kqhztj',
            component: kqhztj
        }, {
            path: '/ggfb',
            name: 'ggfb',
            component: ggfb
        }, {
            path: '/ggfbadd',
            name: 'ggfbadd',
            component: ggfbadd
        }, {
            path: '/jjrwh',
            name: 'jjrwh',
            component: jjrwh
        }, {
            path: '/qxwh',
            name: 'qxwh',
            component: qxwh
        }, {
            path: '/jswh',
            name: 'jswh',
            component: jswh
        }
        , {
            path: '/jswhadd',
            name: 'jswhadd',
            component: jswhadd
        }
        , {
            path: '/cdwh',
            name: 'cdwh',
            component: cdwh
        }
        , {
            path: '/cdwhadd',
            name: 'cdwhadd',
            component: cdwhadd
        }, {
            path: '/kqyr',
            name: 'kqyr',
            component: kqyr
        }, {
            path: '/kqgzwh',
            name: 'kqgzwh',
            component: kqgzwh
        }, {
            path: '/kqgzwhadd',
            name: 'kqgzwhadd',
            component: kqgzwhadd
        }, {
            path: '/lt',
            name: 'lt',
            component: lt
        }, {
            path: '/dktj',
            name: 'dktj',
            component: dktj
        }, {
            path: '/rydkmx',
            name: 'rydkmx',
            component: rydkmx
        }, {
            path: '/xjwh',
            name: 'xjwh',
            component: xjwh
        }, {
            path: '/kqwh',
            name: 'kqwh',
            component: kqwh
        }, {
            path: '/jbwh',
            name: 'jbwh',
            component: jbwh
        }
        
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js